"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var times = require('lodash/times');

function Space(_ref) {
  var n = _ref.n;
  return times(n, function () {
    return /*#__PURE__*/React.createElement("br", null);
  });
}

Space.propTypes = {
  n: PropTypes.number.isRequired
};
module.exports = Space;